var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarSmall({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4a1 1 0 00-1 1v1.006c-.995.029-1.552.163-2.127.475-.601.325-1.077.807-1.398 1.416-.332.628-.46 1.234-.474 2.394L4 15.485c0 1.309.122 1.95.475 2.618.32.609.797 1.09 1.398 1.416.658.357 1.291.481 2.584.481h7.086c1.293 0 1.926-.124 2.585-.48a3.392 3.392 0 001.398-1.417c.352-.667.474-1.31.474-2.618v-4.97c0-1.309-.122-1.95-.474-2.618a3.393 3.393 0 00-1.398-1.416c-.576-.312-1.133-.446-2.128-.475V5a1 1 0 10-2 0v1.001h-4V5a1 1 0 00-1-1zm5 5V8h-4v1a1 1 0 01-2 0v-.978c-.462.035-.722.113-.988.255-.318.17-.564.417-.735.735-.145.271-.223.537-.257 1.015l-.013.258c-.005.139-.007.293-.007.467v4.496l.003.323.004.144.013.258c.034.478.112.744.257 1.015.17.319.417.564.735.735.271.145.537.223 1.015.257l.258.013.144.004.323.003h6.496l.323-.003.144-.004.258-.013c.478-.034.744-.112 1.015-.257.319-.17.564-.416.735-.735.145-.271.223-.537.257-1.015l.013-.258.004-.144.003-.323v-4.496l-.003-.323a9.912 9.912 0 00-.004-.144l-.013-.258c-.034-.478-.112-.744-.257-1.015a1.756 1.756 0 00-.735-.735c-.266-.142-.526-.22-.988-.255V9a1 1 0 11-2 0zm-1 3a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1h-2z"
  })));
}

export default SvgCalendarSmall;